/*
 *  (c) 2015 - 2023 ENISCO by FORCAM GmbH
 */

import {Drawer, IconButton} from '@mui/material'
import React, {Fragment, useEffect, useRef, useState} from 'react'
import MenuIcon from '@mui/icons-material/Menu'
import SearchBar from './SearchBar'
import TabBar from './TabBar'
import useSearch from '../../hooks/useSearch'
import SearchResult from './search/SearchResult'
import {useTheme} from '@mui/material/styles'
import useMediaQuery from '@mui/material/useMediaQuery'

const AppSelector: React.FC = () => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)
  const [search, setSearch] = useSearch()
  const theme = useTheme()
  const mdDown = useMediaQuery(theme.breakpoints.down('md'))
  const buttonRef = useRef(null as null | HTMLButtonElement)
  const [enterPressed, setEnterPressed] = useState(false)

  useEffect(() => {
    const listener = (event: KeyboardEvent) => {
      if (event.ctrlKey && event.key.toLowerCase() === 'e') {
        setAnchorEl(buttonRef.current)
        event.preventDefault()
      }
    }

    document.addEventListener('keyup', listener)

    return () => document.removeEventListener('keyup', listener)
  }, [])

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  return (
    <Fragment>
      <IconButton
        ref={buttonRef}
        edge='start'
        sx={{marginRight: 2}}
        aria-label='menu'
        onClick={handleClick}
        size='large'
      >
        <MenuIcon />
      </IconButton>

      <Drawer
        variant='temporary'
        sx={{flexShrink: 0}}
        PaperProps={{
          sx: {
            width: {xs: '70%', md: '480px'},
            backgroundColor: 'background.dark'
          }
        }}
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <SearchBar
          value={search}
          mdDown={mdDown}
          onChange={(searchString: string) => setSearch(searchString)}
          onEnter={() => {
            if (search) setEnterPressed(true)
          }}
        />
        {search ? (
          <SearchResult
            value={search}
            handleClose={handleClose}
            enterPressed={enterPressed}
            setEnterPressed={setEnterPressed}
          />
        ) : (
          <TabBar handleClose={handleClose} />
        )}
      </Drawer>
    </Fragment>
  )
}

export default AppSelector
